<template>
  <div>
  <form @submit.prevent="validateData()" method="POST" id="login" class="login100-form validate-form flex-sb flex-w">
    <span class="login100-form-title"><img src="../../assets/img/logo.png" alt="carquidiocesanos" style="height: 180px;"></span>
    <div class="p-t-1 p-b-1">
      <p style="text-align:justify">
        En caso de ser proveedor o responsable financiero de un estudiante, por favor digite su documento de identidad para ingresar al sistema y los últimos 4 dígitos del mismo documento como contraseña.
      </p>
    </div>
    <div class="p-t-10 p-b-10">
      <label for="email" class="txt1">Email / Identificación</label>
    </div>
    <div class="field wrap-input">
      <input class="is-shadowless input100" id="email" name="email" type="text" v-model="user.email" required>
    </div>
    <div class="p-t-10 p-b-10">
      <label for="password" class="txt1">{{$t('login.password')}}</label>
    </div>
    <div class="field wrap-input">
      <input class="input100" type="password" name="password" id="password" v-model="user.password" required>
    </div>
    <template v-if="renderCaptcha === true">
      <div class="field wrap-input">
        <vue-recaptcha ref="recaptcha" sitekey="6LdkkHsUAAAAAH8XqHt0gJhgtHhv3t4zcMRgDPBZ" @verify="onVerifyCaptcha" @expired="onExpiredCaptcha" required></vue-recaptcha>
      </div>
    </template>
    <!-- <a @click="goTo('recovery-password')" class="txt2 m-l-5">{{$t('login.forgotPassword')}}</a> -->
    <div class="container-login100-form-btn m-t-17">
      <button class="login100-form-btn">{{$t('login.loginText')}}</button>
    </div>
  </form><br>
  <a @click="downloadFile(1)" style="text-decoration: underline !important;">Descargar manual proveedor</a><br>
  <a @click="downloadFile(2)" style="text-decoration: underline !important;">Descargar manual responsable financiero</a>
  </div>
</template>
<script>
// import VueGkValidate from 'vue-gk-validator'
import performanceService from '@/services/performanceService'
import VueRecaptcha from 'vue-recaptcha'
import env from '@/env'
import { xMisc } from '@/mixins/xMisc.js'
export default {
  name: 'login',
  mixins: [xMisc],
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      renderCaptcha: false,
      passCaptcha: false
    }
  },
  methods: {
    async validateData () {
      // if (VueGkValidate.validate('email', this.user.email)) {
      if (this.user.email) {
        if (this.renderCaptcha) {
          if (!this.passCaptcha) {
            this.alert('danger', this.$t('login.verifyCaptcha'))
            return false
          }
        }
        this.login()
      } else {
        this.user.password = ''
        this.alert('danger', this.$t('general.notValidEmail'))
      }
    },
    async login () {
      var login = await performanceService.login(this.user)
      if (login.data.success) {
        this.$session.start()
        this.$session.set('user', login.data.data)
        this.vSession()
      } else {
        this.alert('danger', login.data.message || this.$t('login.loginFailed'))
      }
      if (login.data.recaptcha) {
        if (this.renderCaptcha) {
          this.$refs.recaptcha.reset()
        }
        this.renderCaptcha = true
        this.passCaptcha = false
      }
    },
    onExpiredCaptcha () {
      this.alert('danger', this.$t('login.expiredCaptcha'))
      this.$refs.recaptcha.reset()
    },
    onVerifyCaptcha () {
      this.passCaptcha = true
    },
    downloadFile (type) {
      window.open(env.API_BASE_URL + '/download/instructive/' + type, '_blank')
    }
  },
  components: {
    VueRecaptcha
  }

}
</script>



// WEBPACK FOOTER //
// src/components/client/Login.vue